import type { AxiosInstance } from "axios";
import type { UseQueryOptions } from "@tanstack/react-query";
import type { EmailMessageDTO } from "../types/dtos/EmailMessageDTO";
import { ticketEmailMessageKeys } from "@repo/types/queries";

export const getEmailMessageByIdQuery = (
  emailMessageId: number,
  apiClient: AxiosInstance,
): UseQueryOptions<string> => ({
  queryKey: ticketEmailMessageKeys.details(emailMessageId),
  queryFn: async () => {
    const response = await apiClient.get<EmailMessageDTO>(
      `/emailMessage/get/${emailMessageId}`,
    );
    return response.data.BodyContent;
  },
  enabled: !!emailMessageId,
});
